import React, {useContext, useState, useMemo} from 'react'

import {type MomentRange} from '../utils'

interface SelectedTimeframeState {
  selectedTimeframe: MomentRange | undefined
  setSelectedTimeframe: (timeframe: MomentRange | undefined) => void
}

const SelectedTimeframeContext = React.createContext<SelectedTimeframeState | undefined>(undefined)

export const useSelectedTimeframe = () => {
  const context = useContext(SelectedTimeframeContext)
  if (!context)
    throw new Error(
      'Cannot use SelectedTimeframeContext outside of a SelectedTimeframeProvider provider'
    )
  return context
}

interface SelectedTimeframeProviderProps {
  children: React.ReactNode
  defaultTimeframe?: MomentRange
}

export const SelectedTimeframeProvider: React.FC<SelectedTimeframeProviderProps> = ({
  children,
  defaultTimeframe
}) => {
  const [selectedTimeframe, setSelectedTimeframe] = useState<MomentRange | undefined>(
    defaultTimeframe
  )

  const memoizedState = useMemo(
    () => ({selectedTimeframe, setSelectedTimeframe}),
    [selectedTimeframe]
  )

  return (
    <SelectedTimeframeContext.Provider value={memoizedState}>
      {children}
    </SelectedTimeframeContext.Provider>
  )
}
